module.exports = __webpack_public_path__ + "static/media/21.42798101.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/files/21.jpeg
// module id = 86
// module chunks = 0